import { reset, SubmissionError, getFormValues } from 'redux-form';
import http from '../../../shared/http';
import endpoints from '../../../../config/endpoints';

import _get from 'lodash/get';
import _pick from 'lodash/pick';
import _path from 'lodash/fp/path';
import _forEach from 'lodash/fp/forEach';
import qs from 'qs';

const defaultInitialState = {
	fields: {
		affiliate_id: null,
		offer_ids: null
	},
	isShow: false,
	disabledFields: []
};

const prepareFormErrors = errors => {
	const validationsErrors = {};
	_forEach(value => {
		const key = value.dataPath.slice(1);
		validationsErrors[key] = value.message;
	}, errors);
	return validationsErrors;
};

const errorReducerFn = (state, action) => {
	if (action.payload.response.status !== 400) {
		return { ...state, error: true, showProgressBar: false };
	}
	return state;
};

const createForm = ({ namespace, stateNodeName, formName }) => {
	const FORM_SUBMIT_SUCCESS = `${namespace}/${stateNodeName}-submit-add-offer-from-affiliate-form-success`;
	const FORM_SUBMIT_ERROR = `${namespace}/${stateNodeName}-submit-add-offer-from-affiliate-form-error`;
	const TOGGLE_FORM = `${namespace}/${stateNodeName}-toggle-add-offer-from-affiliate-form`;
	const OFFERS_LOOKUP_SUCCESS = `${namespace}/${stateNodeName}-OFFERS_LOOKUP_SUCCESS-add-offer-from-affiliate-form`;

	const initialState = { ...defaultInitialState };

	const actions = {
		addOfferFromAffiliateFormSubmit: formData => (dispatch, getState) => {
			const { affiliateId } = getState().affiliateProfile;

			const data = _pick(formData, ['is_included_payouts', 'affiliate_id', 'offer_ids']);
			data.affiliate_id = _get(data, 'affiliate_id.0.value');

			if (data.offer_ids && data.offer_ids.length) {
				data.offer_ids = data.offer_ids.map(item => item.value);
			}
			const request = http({
				url: endpoints.AFFILIATES.COPY_OFFER.replace('{id}', affiliateId),
				method: 'put',
				actions: [FORM_SUBMIT_SUCCESS, FORM_SUBMIT_ERROR],
				data: data
			});

			return dispatch(request)
				.then(action => {
					if (action.type === FORM_SUBMIT_ERROR && action.payload.response.status === 400) {
						const responseErrors = action.payload.response.data;
						throw new SubmissionError(prepareFormErrors(responseErrors));
					} else {
						dispatch(actions.toggleAddOfferFromAffiliateForm());
					}
				});
		},
		toggleAddOfferFromAffiliateForm: () => dispatch => {
			dispatch(reset(formName));
			dispatch({ type: TOGGLE_FORM });
		},
		offersLookupAddOfferForm: text => (dispatch, getState) => {
			const formValues = getFormValues(formName)(getState());
			const affiliate_id = _get(formValues, 'affiliate_id.0.value', '');

			const query = qs.stringify({
				query: text,
				affiliate_id,
				onlyAvailable: true,
				isShowedRemoved: true
			});

			const request = http({
				url: `${endpoints.LOOKUPS.OFFERS}?${query}`,
				method: 'get',
				actions: [OFFERS_LOOKUP_SUCCESS]
			});

			return request(dispatch).then(action => {
				if (action.type === OFFERS_LOOKUP_SUCCESS) {
					return { options: action.payload.data.map(item => ({ value: item.id, label: item.text })) };
				}
			});
		}
	};

	const reducers = {
		[TOGGLE_FORM]: (state, action) => ({
			...state,
			addOfferFromAffiliateForm: {
				...state.addOfferFromAffiliateForm,
				isShow: !state.addOfferFromAffiliateForm.isShow
			}
		}),
		[FORM_SUBMIT_ERROR]: errorReducerFn
	};

	const selectors = {
		getPointFormData: state => {
			const { fields } = _path([namespace, 'addOfferFromAffiliateForm'])(state);
			return {
				initialValues: {
					...fields
				}
			};
		},
		getIsAddOfferFromAffiliateFormVisible: _path([namespace, 'addOfferFromAffiliateForm', 'isShow'])
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

export default createForm;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/add-offer-from-affiliate-form/index.js